import styled from "styled-components";

export const ImageContainer = styled.div`
  padding: 5px;
  padding-left: 10px;
  width: 130px;
  height: 130px;

  @media (max-width: 578px) {
   padding-left: 5px;
   width: 94px;
   height: 94px;
    img {
      max-width: 84px;
      max-height: 84px;
    }
  }
`

export const IsNewMark = styled.div.attrs({ children: "New" })`
  position: absolute;
  left: -18px;
  top: 10px;
  width: 75px;
  height: 20px;
  background: #0a2240;
  color: white;
  font-size: 14px;
  line-height: 1;
  text-align: center;
  transform: rotate(-45deg);
  text-transform: uppercase;
  user-select: none;
`

export const IsSTMark = styled.div.attrs({ children: "FISH TECH" })`
 position: absolute;
 left: -19px;
 top: 14px;
 width: 80px;
 height: 15px;
 background: #0159b7;
 color: #ffffff;
 font-size: 9px;
 line-height: 1.5;
 text-align: center;
 transform: rotate(-45deg);
 text-transform: uppercase;
 user-select: none;
`
export const IsAFMark = styled.div.attrs({ children: "AQUA FARM" })`
  position: absolute;
  left: -19px;
  top: 14px;
  width: 80px;
  height: 15px;
  background: #ff795c;
  color: #ffffff;
  font-size: 9px;
  line-height: 1.5;
  text-align: center;
  transform: rotate(-45deg);
  text-transform: uppercase;
  user-select: none;
`;